import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
export const Flex = ({ children, direction = 'row', justify = 'space-between', }) => (_jsx("div", Object.assign({ css: css `
			display: flex;
			flex-direction: ${direction};
			justify-content: ${justify};
			/* Fixes IE 10/11 bug that collapses this container by default: */
			/* stylelint-disable-next-line property-no-vendor-prefix */
			-ms-flex-positive: 1;
		` }, { children: children }), void 0));
